import React from "react";
import axios from "axios";
import $ from "jquery";
import * as Bootstrap from 'bootstrap/dist/js/bootstrap.js';
import {
	getFromLocalStorage,
    sendToLocalStorage,
    isSimpleNavigation,
    in_array
} from './Utilities';

import ReportsCriteria from './ReportsCriteria';
import ReportsNavigation from './ReportsNavigation';
import DownloadReport from './DownloadReport';
import FavoriteModal from './FavoriteModal';

//Actual reports
import ReportsActiveMembers from './ReportsActiveMembers';
import ReportsAllMembers from './ReportsAllMembers';
import ReportsLoginMembers from './ReportsLoginMembers';
import ReportsCrossoverBrands from './ReportsCrossoverBrands';
import ReportsChannelActivity from './ReportsChannelActivity';
import ReportsActivityTimeline from './ReportsActivityTimeline';
import ReportsCountryActivity from './ReportsCountryActivity';
import ReportsDailyRegistrations from './ReportsDailyRegistrations';
import ReportsSegmentOverviewMetrics from './ReportsSegmentOverviewMetrics';
import ReportsTopActivities from './ReportsTopActivities';

// Registrations
import ReportsLoginTrends from './ReportsLoginTrends';
import ReportsCountryLogins from './ReportsCountryLogins';
import ReportsChannelLogins from './ReportsChannelLogins';
import ReportsLoginDomains from './ReportsLoginDomains';

const md5 = require('md5');

class OtherReportsMenu extends React.Component {

	constructor(props){
        super(props);
        this.state = {
        	currentReport: this.props.currentReport,
        	reports: {},
        };
    }

	componentDidMount(){
        this.getData();
    }

    getData(){
    	axios.get("DashboardPage_Controller/getAvailableReports?viaAjax=1&turnoffdebug=1")
                .then(response => this.formatData(response.data));
    }

    formatData(data){
    	var reports = {};
    	var currentReport = this.props.currentReport;
    	const excludes = [currentReport, "visitor-metrics"];//exclude current report and some reports are specific to other pages eg. segments or ae connect
    	Object.values(data).filter(function(report, key){
    		if(!in_array(report.Slug, excludes)) reports[key] = report;//exclude current report from menu
        });

    	this.setState({
    		reports: reports,
    	});
    }
	
	render(){
		if(Object.keys(this.state.reports).length > 0){
			return (
				<ul className="no-list-style">
					{Object.values(this.state.reports).map((report,index) => {
		                return(<li key={index}>
		                			<a href={"/dashboard/reports/report?report="+report.Slug}>
		                		   		<i className={"fas "+report.Icon+" me-1"}></i> {report.Title}</a>
		                	   </li>);
		            })}				    
				</ul>
			);
		} else {
			return (<div className="react-loading horizontal"></div>);		
		}
	}
}

class GraphButton extends React.Component {
	
	constructor(props){
        super(props);

        let reportData = $("#SessionReportFilters").data('reportInfo');
        var graphAvailable = reportData?.Graph?.toString() || "false";
		var tableAvailable = reportData?.Table?.toString() || "false";
		if(graphAvailable === "false") tableAvailable = "true";//if no graph then there must be a table

        this.state = {
        	view: props.view, //determines whether we display in graph or table view
        	graphAvailable: graphAvailable, //we only display this button if both graph and table are available, ie we need to switch between them
        	tableAvailable: tableAvailable
        };
    }

    onclick = () => {
    	this.setState({
    		view: this.state.view === "graph" ? "table" : "graph"
    	});
    	this.props.onClick();
    }

    render(){	
    	if(this.state.graphAvailable === "true" && this.state.tableAvailable === "true"){
    		var graphButtonText = this.state.view === "graph" ? "Switch to table view" : "Switch to graph view";
	    	return(
	            <button key={this.state.view} onClick={this.onclick.bind(this)} className="btn btn-primary switch-report-view mb-2 mr-10">
	            	{graphButtonText}
	            </button>
	        );
	    } else {
	    	return "";
	    }
    }
}

class ReportsResults extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			values: {},
			simpleNav: false,
			report: {},
			currentFavorite: {},
			view: "graph" // ✅ Default to graph view,
		};
	}

	componentDidMount() {
		this.getData();
		this.getCurrentFavorite();
	}

	getData() {
		let data = $("#SessionReportFilters").data('reportFilters');
		if (Object.keys(data || {}).length > 0) {
			data = sendToLocalStorage("report_data", data);
		} else {
			data = getFromLocalStorage("report_data");
		}
		const simpleNav = data.ReportType ? isSimpleNavigation(data.ReportType.toLowerCase()) : false;
		
		let reportData = $("#SessionReportFilters").data('reportInfo');

		this.setState({
			values: data,
			simpleNav,
			report: reportData,
		});
	}

	getReportData(){
    	return axios.get("DashboardPage_Controller/getAvailableReports?viaAjax=1&turnoffdebug=1&report="+this.state.values.ReportType)
                .then(response => response.data);
    }

	getCurrentFavorite() {
		const current = $("#CurrentFavorite").data("favoriteReportData");
		if (current) {
			this.setState({ currentFavorite: current });
		}
	}

	switchView = () => {
		this.setState(prev => ({
			view: prev.view === "graph" ? "table" : "graph" 
		}));
	}

	openFavoriteModal = (e) => {
		e.preventDefault();
		const myModal = new Bootstrap.Modal($("#FavoriteReportModal"), {});
		myModal.show(true);
	}

	getKey(label) {
		return md5(label + this.state.simpleNav + JSON.stringify(this.state.values));
	}

	renderReportComponent() {
		const report = this.state.values.ReportType;
		const props = {
			reportFilters: 1,
			view: this.state.view,
		};

		switch (report) {
			case "active-members": return <ReportsActiveMembers {...props} />;
			case "all-members": return <ReportsAllMembers {...props} />;
			case "login-members": return <ReportsLoginMembers {...props} />;
			case "crossover-brands": return <ReportsCrossoverBrands {...props} />;
			case "channel-activity": return <ReportsChannelActivity {...props} />;
			case "activity-timeline": return <ReportsActivityTimeline {...props} />;
			case "country-activity": return <ReportsCountryActivity {...props} />;
			case "daily-registrations": return <ReportsDailyRegistrations {...props} />;
			case "visitor-metrics": return <ReportsSegmentOverviewMetrics {...props} />;
			case "top-activities": return <ReportsTopActivities {...props} />;
			case "login-trends": return <ReportsLoginTrends {...props} />;
			case "channel-logins": return <ReportsChannelLogins {...props} />;
			case "country-logins": return <ReportsCountryLogins {...props} />;
			case "login-domains": return <ReportsLoginDomains {...props} />;
			default: return null;
		}
	}

	render() {
		const { currentFavorite, report } = this.state;
		const favoriteText = Object.keys(currentFavorite).length > 0
			? "Update this favorite"
			: "Favorite this search";
		const currentFavoriteID = currentFavorite?.ID || "";

		return (
			<div id="ResultsHolder">
				{/* Header and navigation */}
				<div className="row">
					<div className="col-lg-3 mt-2 mb-2">
						<a href="dashboard/reports" type="button" className="btn btn-light">
							Change your search criteria <i className="mdi mdi-arrow-right me-1"></i>
						</a>
					</div>
					<div className="col-lg-6">
						<div className="card no-bg mt-2 mb-2 ml--25 mr--25">
							<div className="report-steps-small">
								<div className="connecting-line"></div>
								<ReportsNavigation
									key={this.getKey("Navigation")}
									Page="Results"
									reportType={this.state.values.ReportType}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Criteria accordion */}
				<div className="row">
					<div className="col-lg-12 mb-2">
						<div className="ae-accordion ae-accordion-flush" id="ReportCriteriaSoFar">
							<div className="ae-accordion-item">
								<h2 className="accordion-header" id="flush-headingOne">
									<button className="accordion-button show" type="button">
										<i className="ae-arrow"></i>
										Your criteria so far
									</button>
								</h2>
								<div className="ae-accordion-collapse show criteria-holder mt-3">
									<div className="ae-accordion-body criteria">
										<ReportsCriteria
											key={this.getKey("Criteria")}
											Page="Results"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Report content and sidebar */}
				<div className="row">
					<div className="col-lg-10">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<h2 className="header-title mb-3 col-md-12">
										{report.Title}
									</h2>

									<div className="report-buttons col-md-12">
										<GraphButton 
	                                		view={this.state.view} 
	                                		onClick={this.switchView.bind(this)}
	                                	/>

										<button
											type="button"
											className="btn btn-primary mb-2 mr-10"
											data-report-id={currentFavoriteID}
											onClick={this.openFavoriteModal}
										>
											<i className="fas fa-star"></i> {favoriteText}
										</button>

										<DownloadReport />
									</div>

									{/* Render the actual report component */}
									{this.renderReportComponent()}
								</div>
							</div>
						</div>
					</div>

					{/* Sidebar with Other Reports */}
					<div className="col-lg-2">
						<div className="card">
							<div className="card-header bg-secondary py-3">
								<div className="card-widgets">
									<a href="#" data-toggle="remove">
										<i className="mdi mdi-close"></i>
									</a>
								</div>
								<h5 className="card-title mb-0">Other reports</h5>
							</div>
							<div id="cardCollpase5" className="collapse show">
								<div className="card-body text-muted font-14">
									See these results in a different view:
									<OtherReportsMenu currentReport={this.state.values.ReportType} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<FavoriteModal
					key={currentFavoriteID + JSON.stringify(this.state.values)}
					values={this.state.values}
					report={currentFavorite}
				/>
			</div>
		);
	}
}

export default ReportsResults;
